import { CALL_TYPES } from '../constants'

/**
 * Riepilogo compatto di cosa verrà inviato al prossimo messaggio.
 *
 * In una console di debug la configurazione sta nella colonna di sinistra, che scorre:
 * questi chip restano accanto alla chat così si sa sempre con che identità e su che
 * canale si sta scrivendo, senza risalire ai pannelli.
 *
 * @param {Object} props
 * @param {Object} props.config - Configurazione corrente della console
 */
export function RequestSummary({ config }) {
  const callType = CALL_TYPES.find((ct) => ct.value === config.callType)

  const chips = [
    { icon: 'pi-play', value: callType?.label || config.callType, title: 'Tipo chiamata' },
    { icon: 'pi-send', value: config.communicationChannel, title: 'Canale' },
    {
      icon: 'pi-building',
      value: [config.tomcatCode, config.codSociety].filter(Boolean).join('/') || '—',
      title: 'Tomcat code / Cod. società'
    },
    { icon: 'pi-user', value: config.userEmail || '—', title: 'Email utente' }
  ]

  return (
    <div className="debug-summary">
      {chips.map(({ icon, value, title }) => (
        <span className="debug-summary__chip" key={title} title={`${title}: ${value}`}>
          <i className={`pi ${icon}`} />
          {value}
        </span>
      ))}
      {config.isDebug && (
        <span
          className="debug-summary__chip debug-summary__chip--muted"
          title="Debug mode: nessuna scrittura su DB"
        >
          <i className="pi pi-eye-slash" />
          no DB
        </span>
      )}
      {config.sendEmail && (
        <span
          className="debug-summary__chip debug-summary__chip--warn"
          title="Le email vengono inviate davvero"
        >
          <i className="pi pi-envelope" />
          invio reale
        </span>
      )}
    </div>
  )
}
